import React from 'react';
import Storage from '../Storage';
import SheldonSidebarLinks from './SheldonSidebarLinks';
import SheldonCfg from './SheldonCfg';
import SheldonGmaInspect from './SheldonGmaInspect';
import SheldonStats from './SheldonStats';
import SheldonCmd from './SheldonCmd';
import SheldonFileBrowser from './SheldonFileBrowser';
import SheldonSetup from './SheldonSetup';
import SheldonPayapiCmd from './SheldonPayapiCmd';
import SheldonUpdKskCfg from './SheldonUpdKskCfg';
import SheldonTrans from './SheldonTrans';
import Api from '../Api'     ;
import $ from 'jquery';
import SheldonKioskUpdater from './SheldonKioskUpdater';
import SheldonDashBeatCommand from './SheldonDashBeatCommand';
import SheldonLinuxdashCmd from './SheldonLinuxdashCmd';

class Sheldon extends React.Component {

  constructor(props) {
    super(props);
    let view = Storage.getSessionItem('Sheldon:view') || 'filebrowser';
    this.state = {
      panelHeight: 600,
      view: view,
      showSidebar: true,
      kskinfo: {}, // object from kskapi/ksk/info endpoint
      transCheck: {}, // object from kskapi/ksk/cmdalive endpoint
      tqSummary: {}, // object from kskapi/sync/gettqsummary endpoint
      payapiAlive: {}, // object from payapi/alive endpoint
      capuiSettings: {}, // object from capui/settings.json endpoint
    };

    this.calcPanelHeight = this.calcPanelHeight.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.calcPanelHeight();
    $(window).on('resize', this.calcPanelHeight);
    this.fetchTitleInfo(this.props.hostInfo);
  }

  componentWillUnmount() {
    $(window).off('resize', this.calcPanelHeight);
    this.unmounted = true;
  }

  componentWillUpdate(nextProps) {
    // to handle browser page refresh
    if (this.props.hostInfo.id !== nextProps.hostInfo.id) {
      // delay a bit for kskUseVpnIPAddr
      setTimeout(() => {
        this.fetchTitleInfo(nextProps.hostInfo);
      }, 500);
    }
  }

  handleRefreshIconClick(hostInfo) {
    this.setState({ kskinfo: {} }, () => {
      this.fetchTitleInfo(hostInfo);
    });
  }

  async fetchTitleInfo(hostInfo) {
    await this.fetchKskInfo(hostInfo);
    await this.fetchKskTransCheck(hostInfo);
    await this.fetchTqSummary(hostInfo);
    await this.fetchPayapiAlive(hostInfo);
    await this.fetchCapuiSettings(hostInfo);
  }

  fetchKskInfo(hostInfo) {
    if (!hostInfo || !hostInfo.ip) return Promise.resolve();
    return Api.kskapi(hostInfo, '/ksk/info')
      .then((data) => {
        if (this.unmounted) return;
        this.setState({ kskinfo: data });
      })
      .catch((err) => {
        if (this.unmounted) return;
        let msg = err.name + ': Error getting ksk/info from kskapi!';
        this.setState({ kskinfo: { status: 'err', msg: msg } });
      });
  }

  fetchTqSummary(hostInfo) {
    if (!hostInfo || !hostInfo.ip) return Promise.resolve();
    return Api.kskapi(hostInfo, '/sync/gettqsummary')
      .then((data) => {
        if (this.unmounted) return;
        this.setState({ tqSummary: data });
      })
      .catch((err) => {
        if (this.unmounted) return;
        let msg = err.name + ': Error getting transque summary from kskapi!';
        this.setState({ tqSummary: { status: 'err', msg: msg } });
      });
  }

  fetchKskTransCheck(hostInfo) {
    if (!hostInfo || !hostInfo.ip) return Promise.resolve();
    return Api.kskapi(hostInfo, '/ksk/cmdalive')
      .then((data) => {
        if (this.unmounted) return;
        this.setState({ transCheck: data.data });
      })
      .catch((err) => {
        if (this.unmounted) return;
        let msg = err.name + ': Error checking trans server from kskapi!';
        this.setState({ transCheck: { status: 'err', msg: msg } });
      });
  }

  fetchPayapiAlive(hostInfo) {
    if (!hostInfo || !hostInfo.ip) return Promise.resolve();
    return Api.payapi(hostInfo, '/alive')
      .then((data) => {
        if (this.unmounted) return;
        this.setState({ payapiAlive: data });
      })
      .catch((err) => {
        if (this.unmounted) return;
        let msg = err.name + ': Error getting alive info from payapi!';
        this.setState({ payapiAlive: { status: 'err', msg: msg } });
      });
  }

  fetchCapuiSettings(hostInfo) {
    if (!hostInfo || !hostInfo.ip) return Promise.resolve();
    return Api.capui(hostInfo, '/settings.json')
      .then((data) => {
        if (this.unmounted) return;
        this.setState({ capuiSettings: data });
      })
      .catch((err) => {
        if (this.unmounted) return;
        let msg = err.name + ': Error getting settings info from capui!';
        this.setState({ capuiSettings: { status: 'err', msg: msg } });
      });
  }

  handleSidebarLinkClick(view) {
    this.setState({ view }, () => {
      Storage.setSessionItem('Sheldon:view', view);
    });
  }

  handleToggleSidebar() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  calcPanelHeight() {
    let topHeaderHeight = 50;
    let newHeight = $(window).height() - topHeaderHeight;
    // console.log('setPanelHeight', newHeight);
    this.setState({ panelHeight: newHeight });
  }

  render() {
    let hostInfo = this.props.hostInfo;
    let {
      kskdbCCLocalCount,
      kskdbCCLocalXAgo,
      kskdbCCLocalLocalDate,
      kskdbCCQuarantineCount,
      kskdbCCQuarantineXAgo,
      kskdbCCQuarantineLocalDate,
    } = hostInfo;
    let {
      panelHeight,
      view,
      showSidebar,
      kskinfo,
      transCheck,
      tqSummary,
      payapiAlive,
      capuiSettings,
    } = this.state;
    let mode = kskinfo.mode;
    if (mode === 'O') {
      mode = 'Online';
    } else if (mode === 'L') {
      mode = 'Local';
    }

    let rightPanel = null;
    switch (view) {
      case 'filebrowser':
        rightPanel = (
          <SheldonFileBrowser {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />
        );
        break;
      case 'cfg':
        rightPanel = <SheldonCfg {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />;
        break;
      case 'gmainspect':
        rightPanel = (
          <SheldonGmaInspect {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />
        );
        break;
      case 'stats':
        rightPanel = <SheldonStats {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />;
        break;
      case 'trans':
        rightPanel = <SheldonTrans {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />;
        break;
      case 'cmd':
        rightPanel = (
          <SheldonCmd
            {...this.props}
            panelHeight={panelHeight}
            kskinfo={kskinfo}
            onCmdClick={() => {
              this.fetchKskInfo(hostInfo);
              this.fetchCapuiSettings(hostInfo);
            }}
          />
        );
        break;
      case 'payapicmd':
        rightPanel = (
          <SheldonPayapiCmd
            {...this.props}
            panelHeight={panelHeight}
            kskinfo={kskinfo}
            onStatusChanged={() => this.fetchPayapiAlive(hostInfo)}
          />
        );
        break;
      case 'updkskcfg':
        rightPanel = (
          <SheldonUpdKskCfg
            {...this.props}
            panelHeight={panelHeight}
            kskinfo={kskinfo}
            onKskCfgChanged={() => this.fetchKskTransCheck(hostInfo)}
          />
        );
        break;
      case 'setup':
        rightPanel = (
          <SheldonSetup
            {...this.props}
            panelHeight={panelHeight}
            kskinfo={kskinfo}
            onKioskNameChanged={(hostInfo) => {
              this.fetchTitleInfo(hostInfo);
            }}
          />
        );
        break;
      case 'kiosk-updater':
        rightPanel = (
          <SheldonKioskUpdater {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />
        );
        break;
      case 'dashbeat-command':
        rightPanel = (
          <SheldonDashBeatCommand {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />
        );
        break;
      case 'linuxdash-command':
        rightPanel = (
          <SheldonLinuxdashCmd {...this.props} panelHeight={panelHeight} kskinfo={kskinfo} />
        );
        break;
    }

    let refreshKioskInfoIcon = (
      <a
        href='javascript:void(0)'
        onClick={this.handleRefreshIconClick.bind(this, hostInfo)}
        title='refresh kiosk info'
        style={{ marginRight: 10 }}>
        <i className='fa fa-refresh' />
      </a>
    );

    let rightPanelTitle = (
      <div className='sheldon-panel-title'>
        <i className='fa fa-spinner fa-spin fa-fw' /> Loading kiosk info ...
      </div>
    );

    if (kskinfo.status === 'err') {
      rightPanelTitle = (
        <div className='sheldon-panel-title'>
          {refreshKioskInfoIcon}
          <span style={{ color: 'red' }}>{kskinfo.msg}</span>
        </div>
      );
    } else if (kskinfo.kioskname) {
      rightPanelTitle = (
        <div className='sheldon-panel-title'>
          {refreshKioskInfoIcon}
          <span style={{ fontSize: 12, opacity: 0.6 }}> ip:</span>{' '}
          <span style={{ marginRight: '10px' }}>{kskinfo.ip}</span>
          <span style={{ fontSize: 12, opacity: 0.6 }}> ksk: </span>
          <span
            style={{
              marginRight: '10px',
              color: capuiSettings.device !== kskinfo.kioskname ? 'red' : '',
            }}>
            {kskinfo.kioskname}
          </span>
          <span style={{ fontSize: 12, opacity: 0.6 }}> loc:</span>{' '}
          <span style={{ marginRight: '10px' }}>{kskinfo.locname}</span>
          <span style={{ fontSize: 12, opacity: 0.6 }}> org:</span>{' '}
          <span style={{ marginRight: '10px' }}>{kskinfo.orgname}</span>
          <span style={{ fontSize: 12, opacity: 0.6 }}> kskapi:</span>{' '}
          <span style={{ marginRight: '10px' }}>{kskinfo.appver}</span>
          <div>
            <span
              style={{
                fontSize: 14,
                marginRight: '20px',
                color:
                  /Cannot/.test(transCheck.msg) || transCheck.status === 'err' ? 'red' : 'green',
              }}>
              {transCheck.msg}
            </span>
            <span
              style={{
                fontSize: 14,
                color:
                  capuiSettings.device !== kskinfo.kioskname || capuiSettings.status === 'err'
                    ? 'red'
                    : '',
              }}>
              <span style={{ fontSize: 12, opacity: 0.6 }}> device: </span> {capuiSettings.device}
            </span>
            <span
              style={{
                fontSize: 14,
                marginLeft: '20px',
                color: capuiSettings.status === 'err' ? 'red' : '',
              }}>
              <span style={{ fontSize: 12, opacity: 0.6 }}> capui: </span>{' '}
              {capuiSettings.version || capuiSettings.msg || (
                <span>
                  <i className='fa fa-spin fa-refresh' />
                </span>
              )}
            </span>
          </div>
          <div>
            <span
              style={{
                fontSize: 12,
                color: /Local/i.test(mode) || kskinfo.status === 'err' ? 'red' : 'green',
              }}
            >
              {' '}
              kskapi: {mode || kskinfo.msg || <i className='fa fa-spin fa-refresh' />}
            </span>
            <span
              style={{ fontSize: 12, margin: '0 15px', color: tqSummary.cnt ? 'red' : 'green' }}
            >
              {' '}
              TransQue: {tqSummary.cnt}
            </span>
            <span
              style={{
                fontSize: 12,
                margin: '0 15px',
                color:
                  /local/i.test(payapiAlive.procs) || payapiAlive.status === 'err'
                    ? 'red'
                    : 'green',
              }}
            >
              {' '}
              {payapiAlive.procs || payapiAlive.msg || (
                <span>
                  {' '}
                  payapi: <i className='fa fa-spin fa-refresh' />
                </span>
              )}
            </span>
            <span
              style={{
                fontSize: 12,
                margin: '0 15px',
                pointer: 'cursor',
                color: kskdbCCLocalCount > 0 ? 'red' : 'green',
              }}
              title={kskdbCCLocalLocalDate}
            >
              ccLocal: {kskdbCCLocalCount}{' '}
              {kskdbCCLocalXAgo && <span> (since {kskdbCCLocalXAgo})</span>}
            </span>
            <span
              style={{
                fontSize: 12,
                margin: '0 15px',
                pointer: 'cursor',
                color: kskdbCCQuarantineCount > 0 ? 'red' : 'green',
              }}
              title={kskdbCCQuarantineLocalDate}
            >
              ccQuaraintine: {kskdbCCQuarantineCount}{' '}
              {kskdbCCQuarantineXAgo && <span> (since {kskdbCCQuarantineXAgo})</span>}
            </span>
          </div>
        </div>
      );
    }

    let leftClassName = 'pure-u-lg-5-24 pure-u-md-6-24 pure-u-sm-8-24 sheldon-left-panel';
    let rightClasName = 'pure-u-lg-19-24 pure-u-md-18-24 pure-u-sm-16-24 sheldon-right-panel';
    if (!showSidebar) {
      leftClassName = 'hide sheldon-left-panel';
      rightClasName = 'pure-u-24-24 sheldon-right-panel';
    }

    return (
      <div className='sheldon'>
        <div className='pure-u-g' style={{ position: 'relative' }}>
          <div>
            <a
              href='javascript:void(0)'
              style={{
                position: 'absolute',
                top: 10,
                left: 10,
                zIndex: 5,
                color: showSidebar ? 'white' : 'rgba(108, 179, 62, 1)',
              }}
              onClick={this.handleToggleSidebar.bind(this)}
            >
              {showSidebar ? (
                <i className='fa fa-arrow-circle-left' />
              ) : (
                <i className='fa fa-arrow-circle-right' />
              )}
              {showSidebar ? ' collapse' : ' show'}
            </a>
          </div>
          <div className={leftClassName} style={{ height: panelHeight }}>
            <SheldonSidebarLinks
              {...this.props}
              view={view}
              panelHeight={panelHeight}
              onLinkClick={this.handleSidebarLinkClick.bind(this)}
            />
          </div>
          <div className={rightClasName} style={{ height: panelHeight }}>
            {rightPanelTitle}
            {rightPanel}
          </div>
        </div>
      </div>
    );
  }
}

export default Sheldon;



// WEBPACK FOOTER //
// ./src/components/Sheldon.js